
<template>
  <el-form-item :label="params.label" :class="params.className">
    <el-radio-group v-model="value"   size='small' @change='changeType'>
      <template v-if="params.type">
        <el-radio-button
          :label="item.key"
          v-for="item in options"
          :key="item.key"
          >{{ item.value }}</el-radio-button
        >
      </template>
      <template v-else>
        <el-radio :label="item.key" v-for="item in options" :key="item.key">{{
          item.value
        }}</el-radio>
      </template>
    </el-radio-group>
  </el-form-item>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'form-radio',
  props: {
    params: {
      type: Object
    },
    rowData: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(['brands', 'replyTypeList'])
  },
  data() {
    return {
      value: this.rowData
        ? this.rowData[this.params.key]
          ? this.rowData[this.params.key]
          : this.params.value
        : this.params.value,
      options: []
    }
  },
  mounted() {
    // 需转化成 key value 形式
    if (this.params && this.params.options) {
      // 自定义 js写死的
      this.options = this.params.options
    } else if (this[this.params.optionskey]) {
      // 接口获取的 通过 store 保存 mapGetters 返回
      this.options = [...this[this.params.optionskey]].map((val) => {
        return { key: val.key || val.id, value: val.value || val.title }
      })
    }
  },
  methods: {
    reset() {
      if (this.params.dValue) {
        this.radio = this.params.dValue
      } else {
        this.radio = undefined
      }
    },
    getValue() {
      if (this.value || this.value === 0) {
        return {
          [this.params.key]: this.value
        }
      }
      return undefined
    },
    changeType(val) {
      this.$emit('changeType', val)
    }
  },
  watch: {
    value(nv, ov) {
      const cp = JSON.parse(JSON.stringify(this.params))
      cp.value = nv
      this.$emit('csi', cp)
    }
  }
}
</script>
